<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAlert_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M6.656 2.557a1.554 1.554 0 0 1 2.692 0l5.385 9.327a1.554 1.554 0 0 1-1.347 2.332H2.617a1.554 1.554 0 0 1-1.346-2.331zm1.34 8.437c-.403 0-.73.33-.73.735 0 .406.327.734.73.735h.009a.733.733 0 0 0 .731-.735.734.734 0 0 0-.731-.735zm.009-5.879a.734.734 0 0 0-.732.735v2.94c0 .405.328.734.732.734a.733.733 0 0 0 .731-.734V5.85a.734.734 0 0 0-.731-.735"
    />
</svg>
